import { hash } from '@ember/helper';
import { get } from '@ember/object';
import { htmlSafe } from '@ember/template';
import { PhCreditCard } from 'ember-phosphor-icons';
import Popover from 'tio-ui/components/popover';
import { t } from 'ember-intl';
import type { TOC } from '@ember/component/template-only';

export interface CourseCashTagSignature {
  Args: {
    isDirectPayProgram: boolean;
    size?: 'sm' | 'md' | 'lg';
    buttonClass?: string;
    disablePopover?: boolean;
  };
  Blocks: {
    beforeTag: [];
    afterTag: [];
  };
  Element: HTMLDivElement;
}

const CourseCashTag: TOC<CourseCashTagSignature> = <template>
  {{#if @isDirectPayProgram}}
    <div
      ...attributes
      class="inline-flex items-baseline align-baseline gap-1 tio-fg-secondary
        {{if (eq @size 'sm') 'text-sm' (if (eq @size 'lg') 'text-lg' 'text-base')}}"
    >
      <PhCreditCard
        @size={{get (hash sm=16 md=20 lg=24) (if @size @size "md")}}
        class="flex-none mr-1 self-center"
      />

      {{#if (has-block "beforeTag")}}
        {{yield to="beforeTag"}}
      {{/if}}

      {{#if @disablePopover}}
        <span
          class="inline-block leading-none align-baseline {{if @buttonClass @buttonClass}}"
          aria-label={{t "common.tas.course_cash.label"}}
        >
          CourseCa<span
            class="inline-block text-[0.75em] align-baseline {{if @buttonClass @buttonClass}}"
          >$</span>h
        </span><sup class="-ml-1" aria-hidden="true">{{t "common.tas.course_cash.trademark"}}</sup>
      {{else}}
        <Popover @triggerMode="hover">
          <:trigger as |pop|>
            <button
              type="button"
              {{pop.register}}
              {{pop.hoverHandlers}}
              class=""
              aria-label={{t "common.tas.course_cash.label"}}
            >
              <span
                class="underline underline-offset-4 decoration-1 {{if @buttonClass @buttonClass}}"
              >
                CourseCa<span
                  class="inline-block text-[0.75em] align-baseline underline underline-offset-4 decoration-1
                    {{if @buttonClass @buttonClass}}"
                >$</span>h
              </span>
              <sup class="no-underline -ml-1" aria-hidden="true">{{t
                  "common.tas.course_cash.trademark"
                }}</sup>
            </button>
          </:trigger>
          <:body>
            <div class="p-2 tio-col-flush gap-y-2 tio-fg-secondary text-base/7">
              <span class="font-semibold" aria-label={{t "common.tas.course_cash.label"}}>{{htmlSafe
                  (t "common.tas.course_cash.default")
                }}</span>
              <p class="leading-6">{{htmlSafe
                  (t
                    "common.tas.course_cash.description"
                    visuallyStyledCourseCash=(t "common.tas.course_cash.default")
                    plainCourseCash=(t "common.tas.course_cash.label")
                  )
                }}</p>
            </div>
          </:body>
        </Popover>
      {{/if}}

      {{#if (has-block "afterTag")}}
        {{yield to="afterTag"}}
      {{/if}}
    </div>
  {{/if}}
</template>;

export default CourseCashTag;
